<template>
    <div class="form-group--border">
        <h5>{{user.fullName}}</h5>
        <table v-if="user?.employees?.length" class="table table-bordered table-striped">
            <thead>
            <tr>
                <th>Организация</th>
                <th>Должность</th>
                <th>Телефон</th>
                <th>Доб. номер</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="employee in user.employees">
                <td>{{employee.organizationName}}</td>
                <td>{{employee.position}}</td>
                <td>{{employee.phone}}</td>
                <td>{{employee.additionalNumber}}</td>
            </tr>
            </tbody>
        </table>
        <div class="row">
            <div class="col-3">
                <span class="control-label">E-mail:</span>
            </div>
            <div class="col-9">
                {{user.email}}
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <span class="control-label">Телефон:</span>
            </div>
            <div class="col-9">
                {{user.phone}}
            </div>
        </div>
    </div>
</template>

<script>
  import Api from '@/modules/messenger/api/users';
  export default {
    name: "UserProfile",
    props: {
      userId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        user: {}
      }
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        Api.find(this.userId).then((response) => {
          this.user = response.data;
        });
      }
    }
  }
</script>

<style scoped>

</style>